<label for="hora">Selecione a hora:</label>
<input type="text" id="hora" name="hora" [(ngModel)]="hora" (input)="formatarHora()" required>
